import { render, staticRenderFns } from "./VAssetsBySegment.vue?vue&type=template&id=6d7dbb8a&"
import script from "./VAssetsBySegment.vue?vue&type=script&lang=js&"
export * from "./VAssetsBySegment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports